import React, { useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import API_BASE_URL from "../config";
export const showToast = (title, icon = "success") => {
  Swal.fire({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon,
    title,
  });
};

const AddBookingGuests = ({ bookingId, onClose }) => {
  const [guests, setGuests] = useState([""]); // Start with one empty guest input
  const [submitting, setSubmitting] = useState(false);

  if (!bookingId) {
    return null;
  }

  const handleGuestChange = (index, value) => {
    const updatedGuests = [...guests];
    updatedGuests[index] = value;
    setGuests(updatedGuests);
  };

  const handleAddAnotherGuest = () => {
    setGuests([...guests, ""]); // Add another empty input field
  };

  const handleRemoveGuest = (index) => {
    const updatedGuests = [...guests];
    updatedGuests.splice(index, 1);
    setGuests(updatedGuests);
  };

  const handleSubmit = async () => {
    if (guests.length === 0 || guests.some((g) => g.trim() === "")) {
      showToast("Please fill in all guest names before submitting.", "warning");
      return;
    }

    const guestNamesString = guests.join(";");

    try {
      setSubmitting(true);
      await axios.post(`${API_BASE_URL}/event/update-booking`, {
        booking_id: bookingId,
        update_type: "guests",
        value: guestNamesString,
      });
      showToast("Guests added successfully!");
      onClose();
    } catch (error) {
      console.error("Error submitting guests:", error);
      showToast("Failed to add guests.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Guests</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {guests.map((guest, index) => (
          <InputGroup className="mb-2" key={index}>
            <Form.Control
              type="text"
              placeholder={`Guest ${index + 1}`}
              value={guest}
              onChange={(e) => handleGuestChange(index, e.target.value)}
            />
            <Button
              variant="outline-danger"
              onClick={() => handleRemoveGuest(index)}
              disabled={guests.length === 1}
            >
              <i className="bi bi-x-circle-fill"></i>
            </Button>
          </InputGroup>
        ))}
        <Button
          variant="success"
          onClick={handleAddAnotherGuest}
          className="mt-2"
        >
          + Add Another Guest
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Submitting..." : "Submit Guests"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddBookingGuests;
